'use client';
/**
 * Позволяет расширять функциональность обработчиков событий на уровне
 * контейнерных компонентов, сохраняя поддержку отмены передачи управления
 * дополнительному обработчику, когда в обработчике верхнего уровня
 * вызывается event.preventDefault().
 * */ var composeHandlers = function(main, extra, options) {
    var _ref = options || {}, _ref_checkForDefaultPrevented = _ref.checkForDefaultPrevented, checkForDefaultPrevented = _ref_checkForDefaultPrevented === void 0 ? true : _ref_checkForDefaultPrevented, _ref_pickEventFromArgs = _ref.pickEventFromArgs, pickEventFromArgs = _ref_pickEventFromArgs === void 0 ? function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return args[0];
    } : _ref_pickEventFromArgs;
    return function handleEvent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var event = pickEventFromArgs.apply(void 0, [].concat(args));
        main == null ? void 0 : main.apply(void 0, [].concat(args));
        if (!checkForDefaultPrevented || !(event == null ? void 0 : event.defaultPrevented)) {
            return extra == null ? void 0 : extra.apply(void 0, [].concat(args));
        }
    };
};

export { composeHandlers };
